import {
  addMonths,
  subMonths,
  getDaysInMonth,
  setDate,
  getDay,
  addDays,
  addWeeks,
  subDays,
  eachDayOfInterval,
  format,
  add,
  isPast,
} from 'date-fns'
import { fromZonedTime } from 'date-fns-tz'

import { convert12HourTo24Hour } from './convertHour'

export function changeDateMonth(date: Date, isNextMonth: boolean): Date {
  return addMonths(date, isNextMonth ? 1 : -1)
}

export function changeDateWeek(date: Date, isNextMonth: boolean): Date {
  return addWeeks(date, isNextMonth ? 1 : -1)
}

export interface ICalendarCell {
  text: string;
  value: Date;
}

function getCalendarCells(date: Date): ICalendarCell[] {
  const daysArray = new Array(getDaysInMonth(date)).fill(1)
  const calendarCells: ICalendarCell[] = []
  const prepareCell = (date: Date, dayNumber: number) => {
    return {
      text: String(dayNumber),
      value: setDate(date, dayNumber),
    }
  }

  daysArray.forEach((_, i) => {
    calendarCells.push(prepareCell(date, i + 1))
  })

  const unShiftAmount = getDay(calendarCells[0]?.value)
  const unPushAmount = 7 - getDay(calendarCells[calendarCells.length - 1]?.value) - 1

  const lastMonth = subMonths(date, 1)
  for (let i = 0; i < unShiftAmount; i++) {
    calendarCells.unshift(prepareCell(lastMonth, getDaysInMonth(lastMonth) - i))
  }

  const nextMonth = addMonths(date, 1)
  for (let i = 0; i < unPushAmount; i++) {
    calendarCells.push(prepareCell(nextMonth, i + 1))
  }
  return calendarCells
}

export function getCalendarRows(date: Date): Array<ICalendarCell[]> {
  const cells = getCalendarCells(date)
  const rows: Array<ICalendarCell[]> = []

  for (let i = 0; i < cells.length; i += 7) {
    rows.push(cells.slice(i, i + 7))
  }

  return rows
}

export function getActiveRow(date: Date): Array<ICalendarCell> {
  const unShiftAmount = getDay(date)
  const unPushAmount = 7 - getDay(date) - 1

  const startDay = subDays(date, unShiftAmount)
  const endDay = addDays(date, unPushAmount)

  const thisWeek = eachDayOfInterval(
    { start: startDay, end: endDay },
  )

  const rows: ICalendarCell[] = thisWeek.map((day: Date) => {
    return { text: String(getDay(day)), value: day }
  })

  return rows
}

export const isPastTime = (date: Date, time12h: string, timezone: string) => {
  const [hours, minutes] = convert12HourTo24Hour(time12h).split(':')

  const selectedDateTime = add(date, {
    hours: Number(hours),
    minutes: Number(minutes),
  })
  const formattedDateTime = format(selectedDateTime, 'yyyy-MM-dd HH:mm:ss')
  const zonedDateTime = fromZonedTime(formattedDateTime, timezone)
  return isPast(zonedDateTime)
}
